<template>
    <div>
        <header class="g-hd f-bcf">
            <img class="back" @click="backward()" src="../../assets/jxwx/arr_02.png" alt=""> 主诊组绩效排名
        </header>
        <div class="box">
            <div class="progressBox" v-for="item in data" :key="item.id"  @click="toDirector(item)">
                <span class="name">
                    <span>{{item.department_name | depName}}</span>
                    <span>主诊组</span>
                </span>
                <div class="u-progress">
                    <div class="progress_bar progress_bar_02" :style="{width: item.percent}">
                    </div>
                </div>
                <span class="num">{{item.totalFee | moneyP}}</span>
                <img  class="arrIcon" src="../../assets/jxwx/arr_03.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/axios/api";
export default {
    data() {
        return {
            data:this.$route.query.data,
            time:this.$route.query.time,
        };
    },
    filters: {
        depName: function(val) {
            if (val) {
                return val.substring(0, val.length - 3);
            }
        },
    },
    mounted() {},
    methods: {
        backward() {
            this.$router.backward();
            // alert(this.$route.params.isBack)
        },
        
        toDirector(item) {
            if (item.directorId) {
                this.$router.replace({
                    path: "/jxwx/director",
                    query: {
                        departmentId: item.department_id,
                        directorId: item.directorId,
                        today: this.time,
                        isback: true
                    }
                });
            }else{
                this.$toast.fail('该主诊组暂无主任');
            }
        },
    }
};
</script>

<style lang="less" scoped>
.g-hd {
    display: flex;
    align-items: center;
    height: 13.3vw;
    padding: 0 0 0 3.3vw;
    .back {
        width: 2vw;
        font-size: 16px;
        margin-right: 2.6vw;
    }
    .tt {
        margin-left: 4vw;
    }
}
.box {
    background-color: #fff;
    margin-top: 2.6vw;
    padding: 0;
    .progressBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2vw 4vw;
        border-bottom: 1px solid #dedede;
        .u-progress {
            width: 43vw;
            margin: 0 4vw;
        }
        span {
            display: inline-block;
            font-size: 13px;
            box-sizing: border-box;
        }
        .name {
            width: 19vw;
            text-align: right;
            color: #a6a6a6;
            span{
                width: 100%;
            }
        }
        .num {
            width: 20vw;
        }
        .arrIcon{
            width: 2vw;
        }
    }
    .progressBox:first-child{
        border-top: 1px solid #dedede;
    }
    .allSort {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 47.6vw;
        height: 8.5vw;
        margin: 4vw auto 0 auto;
        border: 1px solid #e5323b;
        border-radius: 6px;
        color: #e5323b;
    }
}
</style>





// WEBPACK FOOTER //
// src/jxwx/components/allSort.vue